import { render, staticRenderFns } from "./BannerEdit.vue?vue&type=template&id=9d99b34a&scoped=true"
import script from "./BannerEdit.vue?vue&type=script&lang=js"
export * from "./BannerEdit.vue?vue&type=script&lang=js"
import style0 from "./BannerEdit.vue?vue&type=style&index=0&id=9d99b34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d99b34a",
  null
  
)

export default component.exports